import { State } from '.';
import { Statement } from '../../models/statement';

export const selectors = {
    getCurrentStatementId: (state: State) => {
        const {
            allIds,
            byId
        } = state;
        const statement = byId[allIds[allIds.length - 1] || ''];
        if (statement && !statement.held && !statement.paidDone) {
            return statement.id;
        } else {
            return undefined;
        }
    },
    getLoading: (
        state: State,
        loadingKey: string
    ): boolean => state.loading[loadingKey] || false,
    getStatement: (
        state: State,
        id: Undefinable<string>
    ): Undefinable<Statement> => state.byId[id || ''],
    getStatementIds: (
        state: State
    ): string[] => state.allIds
};
